import getFuncByMode from '../../../utils/getFuncByMode';

import defaultCalc from './default';

export default getFuncByMode({
  mandi: defaultCalc,
  chuck: defaultCalc,
});
